import PropTypes from 'prop-types';
import React from 'react';
import {ListSubheader, Typography} from '@mui/material';

import {SidebarContext} from './Sidebar.jsx';

/**
 * Sidebar header for use as an header in the Sidebar component
 */
export const SidebarHeader = ({label}) => {
  const sidebarContext = React.useContext(SidebarContext);
  const {open} = sidebarContext;

  return (
    <ListSubheader
      sx={{
        background: 'inherit',
        display: open ? 'inline' : 'none',
        paddingX: 1.5,
      }}
    >
      <Typography variant="overline">{label}</Typography>
    </ListSubheader>
  );
};

SidebarHeader.propTypes = {
  /**
   * The label for the sidebar item
   */
  label: PropTypes.string.isRequired,
};

export default SidebarHeader;
